"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormValues = useFormValues;
var _react = require("react");
var _reactRedux = require("react-redux");
var _orderEntrySelector = require("../../../redux/selectors/orderEntrySelector");
function useFormValues(formName) {
  var formSelectorProps = (0, _react.useMemo)(function () {
    return {
      formName: formName
    };
  }, [formName]);
  return (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.selectOrderFormValues)(state, formSelectorProps);
  });
}